import ArrowArray from './ArrowArray';

export default ArrowArray;
